import { ref, onMounted } from 'vue'

export default {
    name: 'FormBooleanField',
    props: {
        checked: {
            type: Boolean,
            required: false
        },
        elementId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const checked = ref(props?.checked ?? false)

        const getHiddenInput = () => document.getElementById(props.elementId)

        const updateHiddenInput = () => {
            const input = getHiddenInput()
            if (!input) return
            input.value = checked.value ? 'true' : 'false'
            input.dispatchEvent(new Event('change', { bubbles: true }))
        }

        const handleChange = () => {
            updateHiddenInput()
        }

        onMounted(() => {
            const input = getHiddenInput()
            if (input) {
                checked.value = input.value === 'true'
            }
        })

        return {
            checked,
            handleChange
        }
    }
}
